import { render, staticRenderFns } from "./crumbs-item.vue?vue&type=template&id=2cf26db7"
import script from "./crumbs-item.vue?vue&type=script&lang=js"
export * from "./crumbs-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports